import useFlipperFlag from "hooks/use_flipper_flag"
import { string, element } from "prop-types"

const FlipperFlagEnabled = ({ name, enabled = null, disabled = null, children }) => {
  return useFlipperFlag(name) ? children || enabled : disabled
}

FlipperFlagEnabled.prototypes = {
  name: string.required,
  enabled: element,
  disabled: element,
  children: element
}

export default FlipperFlagEnabled
